/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { useEffect } from 'react'

import { EuiButtonEmpty } from '@elastic/eui'

import { useExportCCMClusterList } from '@modules/ccm-admin-lib/hooks'
import { addToast } from '@modules/cui/Toasts'
import { FormattedMessage } from '@modules/i18n'
import { downloadAsFile } from '@modules/utils/downloadAsFile'
import { CSV_MIME_TYPE } from '@modules/utils/mimeTypes'

import useCCMClusterSearchFiltersFromQueryString from './hooks'

const ExportTableButton = () => {
  const { activeQueryStringFilters } = useCCMClusterSearchFiltersFromQueryString()

  const {
    mutate: exportClusterList,
    isLoading,
    isSuccess,
    isError,
    data: exportedClusterList,
  } = useExportCCMClusterList()

  useEffect(() => {
    if (!isSuccess) {
      return
    }

    downloadAsFile(
      exportedClusterList,
      `cluster_list_${new Date().toISOString()}.csv`,
      CSV_MIME_TYPE,
    )
  }, [isSuccess, exportedClusterList])

  useEffect(() => {
    if (!isError) {
      return
    }

    addToast({
      title: (
        <FormattedMessage
          id='ccm.cluster-list-page.export-error'
          defaultMessage='Error exporting cluster list. Please try again later.'
        />
      ),
      color: 'danger',
    })
  }, [isError])

  return (
    <EuiButtonEmpty
      onClick={() => {
        exportClusterList({
          self_managed_cluster_id: activeQueryStringFilters.selfManagedClusterId,
          organization_id: activeQueryStringFilters.organizationId,
          license_uid: activeQueryStringFilters.licenseId,
          include_deleted: activeQueryStringFilters.includeDisconnected,
        })
      }}
      iconType='export'
      iconSide='left'
      isLoading={isLoading}
    >
      <FormattedMessage id='ccm.cluster-list-page.export-button' defaultMessage='Export table' />
    </EuiButtonEmpty>
  )
}

export default ExportTableButton
